import { withPublicHOC } from '../../hoc';
import {
  PublicContentContainer,
  PublicPageHeading,
  PublicPageContent,
} from '../../components/styled';

const PublicPage = ({ termsAndConditions }) => {
  return (
    <PublicContentContainer>
      <PublicPageHeading>
        <h1>Terms &amp; Conditions</h1>
      </PublicPageHeading>
      <PublicPageContent
        className="content"
        dangerouslySetInnerHTML={{ __html: termsAndConditions }}
      ></PublicPageContent>
    </PublicContentContainer>
  );
};

export default withPublicHOC(PublicPage);
